import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileText, ExternalLink } from 'lucide-react';

const UserGuides = () => {
    const { t, i18n } = useTranslation();
    const isAr = i18n.language === 'ar';
    const primaryGreen = "#006C35";

    const guides = [
        {
            title: t('userGuides.guide1Title'),
            link: isAr 
                ? "https://rassen.ksu.edu.sa/sites/rassen.ksu.edu.sa/files/%D8%AF%D9%84%D9%8A%D9%84%20%D8%A7%D9%84%D9%85%D8%B3%D8%AA%D8%AE%D8%AF%D9%85%20%D9%84%D9%85%D9%86%D8%B5%D8%A9%20%D9%85%D8%B4%D8%AA%D8%B1%D9%8A%D8%A7%D8%AA%20%D8%AC%D8%A7%D9%85%D8%B9%D8%A9%20%D8%A7%D9%84%D9%85%D9%84%D9%83%20%D8%B3%D8%B9%D9%88%D8%AF%20-%20%D8%A7%D9%84%D9%85%D9%88%D8%B1%D8%AF.pdf"
                : "https://rassen.ksu.edu.sa/sites/rassen.ksu.edu.sa/files/EN%20%D8%AF%D9%84%D9%8A%D9%84%20%D8%A7%D9%84%D9%85%D8%B3%D8%AA%D8%AE%D8%AF%D9%85%20%D9%84%D9%85%D9%86%D8%B5%D8%A9%20%D9%85%D8%B4%D8%AA%D8%B1%D9%8A%D8%A7%D8%AA%20%D8%AC%D8%A7%D9%85%D8%B9%D8%A9%20%D8%A7%D9%84%D9%85%D9%84%D9%83%20%D8%B3%D8%B9%D9%88%D8%AF%20-%20%D8%A7%D9%84%D9%85%D9%88%D8%B1%D8%AF.pdf",
            description: t('userGuides.guide1Desc')
        }
    ];

    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section Header */}
                <div className={`mb-12`}>
                    <h2 className={`text-3xl font-bold text-gray-900 ${isAr ? 'border-r-4 pr-4' : 'border-l-4 pl-4'}`} style={{ borderColor: primaryGreen }}>
                        {t('userGuides.title')}
                    </h2>
                </div>

                {/* Guides Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {guides.map((guide, index) => (
                        <div
                            key={index}
                            className={`group block bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 ${!isAr ? 'text-left' : 'text-right'}`}
                        >
                            <div className={`flex items-start justify-between`}>
                                <div
                                    className="p-3 rounded-xl bg-green-50 text-[#006C35] group-hover:bg-[#006C35] group-hover:text-white transition-colors duration-300"
                                >
                                    <FileText size={28} />
                                </div>
                                <a href={guide.link} target="_blank" rel="noopener noreferrer" className="text-gray-300 group-hover:text-[#006C35] hover:bg-gray-100 hover:rounded-full p-2 w-10 h-10 flex items-center justify-center transition-colors">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="inline-block" width={20} height={20} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                    </svg>
                                </a>
                            </div>

                            <h3 className="mt-6 text-xl font-bold text-gray-900 leading-snug group-hover:text-[#006C35] transition-colors">
                                {guide.title}
                            </h3>

                            <p className="mt-4 text-gray-500 text-sm leading-relaxed">
                                {guide.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default UserGuides;
